import React from "react"

import Layout from "../components/layout"
import MediaFeature from "../components/MediaFeature"
import FeatureList from "../components/FeatureList"
import TabbedContent from "../components/TabbedContent"
import IconGrid from "../components/IconGrid"
import Quote from "../components/Quote"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO
      defer={false}
      title="Stack: Sales Enablement Software & Sales Tool"
      description="Stack is a sales enablement platform to help scale your start-up and guide you through everything from accelerators and investors to your sales cycle and strategy"
    />
    <MediaFeature
      filename="sale_cycle.png"
      content={
        <>
          <h1>
            Sell efficiently <br />
            Scale rapidly
          </h1>
          <p>
            Stack is a lightweight platform that helps startups with sales
            enablement as a compliment to your CRM.
          </p>
        </>
      }
    />
    <FeatureList
      content={
        <>
          <h2>Get Enterprise and Investment Ready</h2>
          <p>
            The Stack platform gives your startup a flexible digital framework
            to implement the building blocks to success, allowing you to ramp up
            and reach your goals.
          </p>
        </>
      }
    ></FeatureList>
    <Quote
      quote="After following the Stack process, we implemented a sales engine that resulted in us closing the year with 3X YoY growth, momentum that was carried into the next year. This clear, concise and focused sales process was a big part of our ability to be successful raising our Series A funding."
      position="Co-Founder, CEO, BridgeFT"
      name="Rasheed Hammouda"
      padding
    />
    <MediaFeature
      content={
        <>
          <h2>Stack is a practical business tool that you’ll use daily</h2>
          <p>
            Within Stack you can define your business, sales and client goals,
            so you know exactly what you’re aiming for. Once you have your
            strategy in place, you can work out the most efficient use of your
            time, build your ideal client and partner profile and establish the
            fundamental building blocks to create a consistent and repeatable
            sales cycle. Plus you have tools, tips and guidance to plan, execute
            and measure the success of your refined approach.
          </p>
        </>
      }
    />
    <MediaFeature
      filename="sale_cycle.png"
      content={
        <>
          <h1>
            Sell efficiently <br />
            Scale rapidly
          </h1>
          <p>
            Stack is a lightweight platform that helps startups with sales
            enablement as a compliment to your CRM.
          </p>
        </>
      }
    />
    <IconGrid></IconGrid>
    <TabbedContent></TabbedContent>
  </Layout>
)

export default IndexPage
